import React, { useContext } from "react";

import { TimelinePage, TimelineScreen } from "./timeline.styles";
import { Fade } from "react-reveal";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";

import { Icon } from "@iconify/react";
import { ThemeContext } from "../../theme.context";

const Timeline = () => {
  const { darkMode } = useContext(ThemeContext);
  return (
    <TimelinePage dark={darkMode}>
      <div class="wave1">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            class="shape-fill"
            fill={darkMode ? "#FF3B81" : "#3957D2"}
          ></path>
        </svg>
      </div>
      <TimelineScreen id="timeline-section" dark={darkMode}>
        <Fade left>
          <h1 className="page-title">SEE MY JOURNEY!</h1>
        </Fade>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            // contentStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
            // contentArrowStyle={{ borderRight: "7px solid  rgb(33, 150, 243)" }}
            date="2020 - 2024"
            iconStyle={{
              background: darkMode ? "#22262E" : "#fff",
              color: darkMode ? "#FF3B81" : "#3957D2",
            }}
            icon={<Icon icon="zondicons:education" />}
          >
            <h3 className="vertical-timeline-element-title">
              B Tech in Computer Science
            </h3>
            <h4 className="vertical-timeline-element-subtitle">
              Vishwakarma Institute Of Technology
            </h4>
            <p>CGPA: 9.1</p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            // contentStyle={{background:"#fff",boxShadow:'0px 8px 20px rgba(35, 35, 35, 0.1)'}}
            date="2018-2021"
            iconStyle={{
              background: darkMode ? "#22262E" : "#fff",
              color: darkMode ? "#FF3B81" : "#3957D2",
            }}
            icon={<Icon icon="zondicons:education" />}
          >
            <h3 className="vertical-timeline-element-title">Junior College</h3>
            <h4 className="vertical-timeline-element-subtitle">
              Birla College Of Science, Commerce and Arts, Kalyan
            </h4>
            <p>Percentage: 84%</p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2018"
            iconStyle={{
              background: darkMode ? "#22262E" : "#fff",
              color: darkMode ? "#FF3B81" : "#3957D2",
            }}
            icon={<Icon icon="zondicons:education" />}
          >
            <h3 className="vertical-timeline-element-title">School</h3>
            <h4 className="vertical-timeline-element-subtitle">
              Rita Memorial High School, Kalyan
            </h4>
            <p>SSC percentage: 95%</p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="May 2022- Nov 2022"
            iconStyle={{
              background: darkMode ? "#22262E" : "#fff",
              color: darkMode ? "#FF3B81" : "#3957D2",
            }}
            icon={<Icon icon="ic:round-work" />}
          >
            <h3 className="vertical-timeline-element-title">
              Full Stack developer developer internship
            </h3>
            <h4 className="vertical-timeline-element-subtitle">Elecbits</h4>
            <p>
              Working as a full stack developer intern at Elecbits with a
              mission of making electronics development and manufacturing
              extremely easy.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Oct 2021 - Jan 2022"
            iconStyle={{
              background: darkMode ? "#22262E" : "#fff",
              color: darkMode ? "#FF3B81" : "#3957D2",
            }}
            icon={<Icon icon="ic:round-work" />}
          >
            <h3 className="vertical-timeline-element-title">
              React developer internship
            </h3>
            <h4 className="vertical-timeline-element-subtitle">Manbal.ai</h4>
            <p>
              Worked as a full time intern as a frontend react developer at
              Manbal.ai. Learned and worked with a lot of technologies including
              react, redux, material ui, etc.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="October, 2022"
            iconStyle={{
              background: darkMode ? "#22262E" : "#fff",
              color: darkMode ? "#FF3B81" : "#3957D2",
            }}
            icon={<Icon icon="fa-solid:medal" />}
          >
            <h3 className="vertical-timeline-element-title">
              1st place in Hacksprint 4.0
            </h3>
            <h4 className="vertical-timeline-element-subtitle">MMCOE Pune</h4>
            <p>
              Hacksprint is a annual national hackathon organized by MMCOE Pune
              and is open for student of all colleges and education
              years.Securead 1st place by creating a fully functional book
              rental system
              <b> BookMyBook</b>
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="October, 2022"
            iconStyle={{
              background: darkMode ? "#22262E" : "#fff",
              color: darkMode ? "#FF3B81" : "#3957D2",
            }}
            icon={<Icon icon="fa-solid:medal" />}
          >
            <h3 className="vertical-timeline-element-title">
              1st place in Flipr Hackathon
            </h3>
            <h4 className="vertical-timeline-element-subtitle">
              Flipr - web domain
            </h4>
            <p>
              Secured 1st place in web development domain in Flipr Hackathon by
              creating a fully working and <b>hosted</b> online workflow
              management system
              <b> Workfloe</b>
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="September, 2022"
            iconStyle={{
              background: darkMode ? "#22262E" : "#fff",
              color: darkMode ? "#FF3B81" : "#3957D2",
            }}
            icon={<Icon icon="fa-solid:medal" />}
          >
            <h3 className="vertical-timeline-element-title">
              2nd place IAS Hackathon
            </h3>
            <h4 className="vertical-timeline-element-subtitle">
              Integral Ad Sciences, Pune
            </h4>
            <p>
              IAS organized a hackathon which consisted of two rounds. We nailed
              the first coding round and got selected for the in offlice
              hackathon. Also we secured 2nd place int the offline hackathon by
              creating a complete <b>Files based database</b> that can support
              upto <b>1M entries</b> with each operation in <b>O(1)</b> time
              complexity
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="May, 2022"
            iconStyle={{
              background: darkMode ? "#22262E" : "#fff",
              color: darkMode ? "#FF3B81" : "#3957D2",
            }}
            icon={<Icon icon="fa-solid:medal" />}
          >
            <h3 className="vertical-timeline-element-title">
              1st place in LaunchHacks 2022
            </h3>
            <h4 className="vertical-timeline-element-subtitle">Launch Hacks</h4>
            <p>
              Launchhacks is a international hackathon in which we submitted our
              project <b>Petto</b> which was an advanced,more functional and
              beautiful version of our earlier project Petscape.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="March, 2022"
            iconStyle={{
              background: darkMode ? "#22262E" : "#fff",
              color: darkMode ? "#FF3B81" : "#3957D2",
            }}
            icon={<Icon icon="fa-solid:medal" />}
          >
            <h3 className="vertical-timeline-element-title">
              2nd place in CODEBREAK 3.0 hackathon
            </h3>
            <h4 className="vertical-timeline-element-subtitle">MIT-ADT Pune</h4>
            <p>
              Codebreak is a annual national hackathon organized by MIT-ADT Pune
              and is open for student of all colleges and education
              years.Securead 2nd place by creating a sustainable [roject named{" "}
              <b> Petscape</b>
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="February, 2022"
            iconStyle={{
              background: darkMode ? "#22262E" : "#fff",
              color: darkMode ? "#FF3B81" : "#3957D2",
            }}
            icon={<Icon icon="fa-solid:medal" />}
          >
            <h3 className="vertical-timeline-element-title">
              2nd place in HackNYU international hackathon
            </h3>
            <h4 className="vertical-timeline-element-subtitle">
              Education track
            </h4>
            <p>
              HackNYU is an international hackathon organized by New York
              University.Secured 2nd place in education track by creating a
              efficient and economical direct teacher to parent interface named
              <b> Follow Up</b>
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--education"
            date="January 2022"
            iconStyle={{
              background: darkMode ? "#22262E" : "#fff",
              color: darkMode ? "#FF3B81" : "#3957D2",
            }}
            icon={<Icon icon="fa-solid:medal" />}
          >
            <h3 className="vertical-timeline-element-title">
              1st place in Unscript Rookies hackathon
            </h3>
            <h4 className="vertical-timeline-element-subtitle">Web domain</h4>
            <p>
              Unscript Rookies hackathon is a special hackathon organized for
              second year student across India. Secured 1st place in web domain
              by creating a onine education course system with payment
              integraion names <b> Studify</b>
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </TimelineScreen>
    </TimelinePage>
  );
};

export default Timeline;
